var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10.313,
    viewBox: "0 0 15 10.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 -2.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M15,7.5S12.188,2.344,7.5,2.344,0,7.5,0,7.5s2.813,5.156,7.5,5.156S15,7.5,15,7.5ZM1.1,7.5A12.312,12.312,0,0,1,2.656,5.585,6.985,6.985,0,0,1,7.5,3.281a6.991,6.991,0,0,1,4.845,2.3A12.312,12.312,0,0,1,13.9,7.5c-.054.082-.114.172-.183.27a12.363,12.363,0,0,1-1.373,1.645,6.993,6.993,0,0,1-4.845,2.3,6.991,6.991,0,0,1-4.845-2.3A12.313,12.313,0,0,1,1.1,7.5Z",
    fill: "#b88100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M7.5,5.156A2.344,2.344,0,1,0,9.844,7.5,2.344,2.344,0,0,0,7.5,5.156ZM4.219,7.5A3.281,3.281,0,1,1,7.5,10.781,3.281,3.281,0,0,1,4.219,7.5Z",
    fill: "#b88100"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowEye);
export default __webpack_public_path__ + "static/media/yellow-eye.801905636c69f0e92f8b3de8466f5945.svg";
export { ForwardRef as ReactComponent };